export const decisionCoseToStatus = {
  803370000: 'Awaiting Review',
  803370001: 'Requested Additional Information',
  803370002: 'Declined',
  803370004: 'Pre-Approved',
  803370003: 'Approved',
};

export const decisionCodeToStatus = {
  'Awaiting Review': 803370000,
  'Requested Additional Information': 803370001,
  Declined: 803370002,
  'Pre-Approved': 803370004,
  Approved: 803370003,
};
